import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Attraction, SHOW_ATTRACTION_PRICE } from '../../models/attraction.model';
import { heroImageUrl, formatAttractionPrice } from '../attraction-utils';

/**
 * Horizontal-carousel tile for the "Attractions you can't miss" strip (Android `AttractionTile`):
 * a 170px column of image → title → rating → price.
 */
@Component({
    selector: 'app-attraction-tile',
    templateUrl: './attraction-tile.component.html',
    styleUrls: ['./attraction-tile.component.scss'],
    host: { class: 'attractions-scope' },
    standalone: false
})
export class AttractionTileComponent {
  @Input() attraction!: Attraction;
  @Output() tileClick = new EventEmitter<string>();

  get imageUrl(): string | null {
    return heroImageUrl(this.attraction);
  }

  get price(): string | null {
    return SHOW_ATTRACTION_PRICE
      ? formatAttractionPrice(this.attraction.starting_price, this.attraction.currency)
      : null;
  }

  onClick(): void {
    if (this.attraction.provider_product_id) {
      this.tileClick.emit(this.attraction.provider_product_id);
    }
  }
}
